export const ARTICLE_ACTION_TYPES = {
  VIEW: 'VIEW',
  INTERNAL: 'VIEW',
}
